document.addEventListener('DOMContentLoaded', function() {
    const productDescription = document.querySelector('.product-description');
    if (productDescription) {
      
      function createSkeletonLoader(itemCount = 3) {
        const skeleton = document.createElement('div');
        skeleton.className = 'product-description-skeleton';
        
        const widths = ['80%', '80%', '80%', '80%', '68%', '68%', '68%', '68%', '68%'];
        const count = Math.min(itemCount, widths.length);
        
        for (let i = 0; i < count; i++) {
          const skeletonItem = document.createElement('div');
          skeletonItem.className = 'product-description-skeleton-item';
          
          const skeletonHeader = document.createElement('div');
          skeletonHeader.className = 'product-description-skeleton-header';
          
          const skeletonText = document.createElement('div');
          skeletonText.className = 'product-description-skeleton-text';
          skeletonText.style.width = widths[i];
          
          skeletonHeader.appendChild(skeletonText);
          skeletonItem.appendChild(skeletonHeader);
          skeleton.appendChild(skeletonItem);
        }
        
        return skeleton;
      }
      
      function generateAccordion() {
        const headers = productDescription.querySelectorAll('h3');
        
        // Show skeleton immediately - always create 9 items
        const skeleton = createSkeletonLoader(9);
        productDescription.parentNode.insertBefore(skeleton, productDescription);
        
        if (headers.length <= 1) {
          // No accordion needed, just show content after delay
          setTimeout(() => {
            productDescription.classList.add('accordion-ready');
            if (skeleton && skeleton.parentNode) {
              skeleton.remove();
            }
          }, 300);
          return;
        }

        // Small delay to show skeleton (simulating processing time)
        setTimeout(() => {
          productDescription.classList.add('product-description-accordion');
          
          // Convert NodeList to Array and process only once
          const headersArray = Array.from(headers);
          const processedHeaders = new Set();
          
          headersArray.forEach((header, index) => {
            // Skip if this header has already been processed or is inside accordion content
            if (processedHeaders.has(header) || header.closest('.product-description-accordion-content')) {
              return;
            }
            
            const content = [];
            let sibling = header.nextElementSibling;
          
            while (sibling && sibling.tagName.toLowerCase() !== 'h3') {
              content.push(sibling);
              sibling = sibling.nextElementSibling;
            }

            if (content.length > 0) {
              const accordionItem = document.createElement('div');
              accordionItem.className = 'product-description-accordion-item';

              const button = document.createElement('button');
              button.className = 'product-description-accordion-header';
              button.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');
              button.setAttribute('type', 'button');
              
              if (index === 0) {
                button.classList.add('expanded');
              }

              const headerText = document.createElement('span');
              headerText.textContent = header.textContent;
              
              const iconContainer = document.createElement('span');
              iconContainer.className = 'product-description-accordion-icon';

              button.appendChild(headerText);
              button.appendChild(iconContainer);

              const contentContainer = document.createElement('div');
              contentContainer.className = 'product-description-accordion-content';
              
              if (index === 0) {
              contentContainer.classList.add('expanded');
            }

            content.forEach(element => {
              contentContainer.appendChild(element);
            });

            button.addEventListener('click', function() {
              const isExpanded = button.classList.contains('expanded');
              
              const allButtons = productDescription.querySelectorAll('.product-description-accordion-header');
              const allContents = productDescription.querySelectorAll('.product-description-accordion-content');
              
              allButtons.forEach(btn => {
                btn.classList.remove('expanded');
                btn.setAttribute('aria-expanded', 'false');
              });
              
              allContents.forEach(content => {
                content.classList.remove('expanded');
              });

              if (!isExpanded) {
                button.classList.add('expanded');
                button.setAttribute('aria-expanded', 'true');
                contentContainer.classList.add('expanded');
              }
            });

            accordionItem.appendChild(button);
            accordionItem.appendChild(contentContainer);

            header.parentNode.insertBefore(accordionItem, header);
            header.remove();
            
            // Mark this header as processed
            processedHeaders.add(header);
          }
        });
        
        // Remove skeleton loader after accordion is built
        productDescription.classList.add('accordion-ready');
        if (skeleton && skeleton.parentNode) {
          skeleton.remove();
        }
      }, 300); // 300ms delay to show skeleton
      }

      generateAccordion();
    }
  });